import { clsx } from 'clsx';
import { FunctionComponent, ReactNode } from 'react';

type DataTableColumn = {
    key: string;
    value: string;
    visible: boolean;
};

type DataTableRow = Record<string, string | ReactNode>;

type DataTableProperties = {
    columns: DataTableColumn[];
    rows: DataTableRow[];
};

export const DataTable: FunctionComponent<DataTableProperties> = ({ columns, rows }) => {
    return (
        <table className="min-w-full table-fixed border-separate border-spacing-0" data-testid={'data-table'}>
            <thead>
                <tr>
                    {columns.map((column, index) => {
                        return (
                            <th
                                className={clsx('border-b border-b-gray-200 px-4 pb-3 text-left text-sm font-semibold text-gray-900', {
                                    'min-w-28': index !== 0,
                                })}
                                key={column.key}
                                scope="col"
                            >
                                <div className={clsx('whitespace-nowrap', { hidden: !column.visible })}>{column.value}</div>
                            </th>
                        );
                    })}
                </tr>
            </thead>
            <tbody>
                {rows.map((row, rowIndex) => {
                    return (
                        <tr
                            className={clsx({
                                'bg-gray-50': rowIndex % 2 === 0,
                            })}
                            key={rowIndex}
                        >
                            {columns.map((column, columnIndex) => {
                                return (
                                    <td
                                        className={clsx('table-cell whitespace-nowrap border-t border-t-gray-200 p-4 text-xs text-gray-500', {
                                            'border-t-0': rowIndex === 0,
                                            'font-medium text-gray-900': columnIndex === 0,
                                        })}
                                        key={column.key}
                                    >
                                        {row[column.key]}
                                    </td>
                                );
                            })}
                        </tr>
                    );
                })}
            </tbody>
        </table>
    );
};
